import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

// ID-078: catalog SKU lookup — only existing, non-archived SKUs can be chosen
export const SkuPicker = ({ value, onPick, testid }) => {
  const [q, setQ] = useState(value || "");
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [pos, setPos] = useState(null);
  const ref = useRef(null);
  const place = () => {
    const b = ref.current?.getBoundingClientRect();
    const dlg = ref.current?.closest("[role=dialog]");
    const d = dlg?.getBoundingClientRect(); // dialog is transformed + scrollable → fixed behaves like absolute inside it
    if (b) setPos({ left: b.left - (d?.left || 0) + (dlg?.scrollLeft || 0), top: b.bottom + 4 - (d?.top || 0) + (dlg?.scrollTop || 0) });
  };
  useEffect(() => { setQ(value || ""); }, [value]);
  useEffect(() => {
    if (!open || !q.trim()) { setItems([]); return undefined; }
    const t = setTimeout(() => {
      api.get("/containers/reconcile/sku-search", { params: { q: q.trim() } }).then(({ data }) => setItems(data)).catch(() => setItems([]));
    }, 200);
    return () => clearTimeout(t);
  }, [q, open]);
  return (
    <div className="relative">
      <Input value={q} ref={ref} onChange={(e) => { setQ(e.target.value.toUpperCase()); place(); setOpen(true); }} onFocus={() => { place(); setOpen(true); }}
        onBlur={() => setTimeout(() => setOpen(false), 150)} placeholder="Search SKU" className="h-8 w-28 font-mono text-xs" data-testid={testid} />
      {open && items.length > 0 && (
        <ul style={pos ? { position: "fixed", left: pos.left, top: pos.top } : undefined} className="z-[100] max-h-56 w-72 overflow-y-auto rounded-md border border-border bg-white shadow-lg" data-testid={`${testid}-options`}>
          {items.map((v) => (
            <li key={v.variant_id}>
              <button type="button" className="w-full px-3 py-2 text-left text-xs hover:bg-alabaster" data-testid={`${testid}-option-${v.sku}`}
                onMouseDown={(e) => { e.preventDefault(); onPick(v); setQ(v.sku); setOpen(false); }}>
                <span className="font-mono text-charcoal">{v.sku}</span> <span className="text-warmgrey">· {v.label}{v.status && v.status !== "ACTIVE" ? ` · ${v.status.toLowerCase()}` : ""}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
